export type BaseDict = {
    MyPulseBets: string
    PlaceBet: string,
    PleaseLoginToPlaceBet: string,
    PulseBetInterval: string,
    TimeIsSeconds: string,
    ErrorMessage: string,
    StartsLabel: string,
    GoLabel: string,
    GermanTaxesMessage: string,
    GeneralMessage: string,
    BetWasAccepted: string,
    TicketLabel: string,
    GoToMyPulseBets: string,
    Suspended: string,
    Sec: string,
    Branch1_1441_: string,
    Branch1_1442_: string,
    Branch1_1443_: string,
    Branch1_1444_: string,
    UseFreeBets: string,
    UseMyBalance: string,
    SelectFreeBet: string
}

export const BaseDict: BaseDict = {
    MyPulseBets: "My Pulse Bets",
    PlaceBet: "Place Pulse Bet",
    PleaseLoginToPlaceBet:"LOGIN TO BET",
    PulseBetInterval: "1 min Pulse",
    TimeIsSeconds: "Sec",
    ErrorMessage: "Error message",
    StartsLabel: "Starts In",
    GoLabel: "Go",
    GermanTaxesMessage: "In accordance with German tax law, {0} % tax will be deducted your total return.",
    GeneralMessage: "This is general message",
    BetWasAccepted: "Your bet was accepted",
    TicketLabel: "Ticket",
    GoToMyPulseBets: "Go to my pulse bets",
    Suspended: "Suspended",
    Sec: "Sec",
    Branch1_1441_: "",
    Branch1_1442_: "",
    Branch1_1443_: "",
    Branch1_1444_: "",
    UseFreeBets: "Use Free Bet",
    UseMyBalance: "Use My Balance",
    SelectFreeBet: "Select Free bet"
}